import classNames from "classnames";
import { use } from "react";
import { SortableItemContext } from "../../../../../common/components/sortable/SortableItemContext";
import styles from "./DragHandle.module.scss";

type Props = {
  isDraggable: boolean;
};

export const DragHandle = ({ isDraggable }: Props) => {
  const { draggableElementProps } = use(SortableItemContext);

  return (
    <div
      {...draggableElementProps}
      className={classNames(styles.dragBox, { [styles.hoverable as string]: isDraggable })}
    >
      <span className={styles.dots}></span>
    </div>
  );
};
